{
	"ariaLogInToDesktopApp": "Log In To Desktop App",
	"openBrowser": "Open Browser to Log In"
}
